import { BallBg } from 'components';
import { Api } from 'lib';
import { useEffect, useState } from 'react';
import { Banner, Sponsor, Teams } from './components';

const Partners = (props) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchInitial();
  }, []);

  async function fetchInitial() {
    const res = await Api.post('/website/fetchInitial');
    if (!res) return;

    setData(res);
  }

  return (
    <div style={{ marginBottom: 84 }}>
      <BallBg />
      <Banner />
      <Sponsor />
      <Teams data={data?.teams} />
    </div>
  );
};

export default Partners;
